import { FieldArray, useFormikContext } from 'formik';
import { useParams, Link } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form, Input as AntInput, Button as AntButton, Select, Modal, Table, Tooltip, message } from 'antd';
import { useOrderemptySave, useOrderemptyUpdate } from 'store/server/useOrder';
import DisliSayisiDetayModal from 'components/form/modals/DisliSayisiDetayModal';
import { Input as FormikInput } from 'components/form/input';
import { Input as UIInput } from 'components/ui/input';
import { Button as UIButton } from 'components/ui/button';
import { toast } from 'components/ui/use-toast';
import { RotateCcw, X } from 'lucide-react';
import { RxCross1 } from "react-icons/rx";
import { SelectReferanceCode8 } from 'components/form/compobox/select-referance-code8';
import requests from 'service/api';
import { useAuth } from 'store/client/authStore'

const { Option } = Select;

export default function EmptyInstructions({ currentTab }) {
  const { values, setFieldValue } = useFormikContext();
  const { mutate: saveOrder, isPending } = useOrderemptySave();
  const { mutate: updateOrder, isPending: isPendingUpdate } = useOrderemptyUpdate();
  const { brand, orderNo, dept, subDept } = useParams();
  const [isDisliModalVisible, setIsDisliModalVisible] = useState(false)

  const brandId = brand.split('_')[0];
  const fieldArrayPushRef = useRef(null);
  const { user } = useAuth()

  // Default initialization for `emptyLabel`
  useEffect(() => {
    if ((!values.emptyLabel || values.emptyLabel.length === 0) && fieldArrayPushRef.current) {
      fieldArrayPushRef.current({
        customerOrderNo: '',
        customerOrderDetail: '',
        colorCode: '',
        referanceCode: '',
      });
    }
  }, [values.emptyLabel]);
  const DrawerContent4 = () => {
    const [form4] = Form.useForm()
    const [GrafDurum, setGrafDurum] = useState([]) // Tablo verileri için state
    const [GrafDurumOld, setGrafDurumOld] = useState([]) // Tablo verileri için state
    const [searchText, setSearchText] = useState('') // Tablo verileri için state
    const [isRowModalVisible, setIsRowModalVisible] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null); // Seçilen satırdaki veri
    const [colordsx, setcolordsx] = useState([
      { code: "W", text: " WHITE" },
      { code: "B", text: "BLACK" },
    ]);

    // React Query ile veri çekimi
    const { data, isFetched, refetch } = useQuery({
      queryKey: ['/list', 'referance', 'BOS DUGME'],
      queryFn: async () => {
        const { data } = await requests.referance.list({ labelCategory: 'BOS DUGME' })
        return data
      },
      placeholderData: []
    })

    // useEffect ile her girişte veri yeniden çekilsin
    useEffect(() => {
      refetch().then((response) => {
        console.log('Refetched Data:', response.data) // Gelen veriyi konsola yazdır
        const isWasgingLabel = response.data.filter(
          (item) => item.labelCategory === 'BOS DUGME'
        )

        setGrafDurum(isWasgingLabel)
        setGrafDurumOld(isWasgingLabel)
      })
    }, [refetch])

    // Uyarı etiketleri için filtreleme

    const onSipNoFinishGrafik = (values) => {
      const requiredFields = ['code', 'name', 'height','width', 'kod', 'a', 'backgroundColor'];
      const emptyFields = requiredFields.filter((field) => !values[field]);

      // Eğer boş alan varsa hata döndür
      if (emptyFields.length > 0) {
        const fieldNames = {
          code: 'Kod',
          name: 'İsim',
          height: 'Yükseklik',
          width:'Genişlik',
          kod: 'Kod',
          a: 'A Değeri',
          backgroundColor: 'Arkaplan Rengi',
          line1:'Satır 1',
          line2:"Satır 2",
    
        };
        const missingFields = emptyFields.map((field) => fieldNames[field]).join(', ');
        message.error(`Lütfen şu alanları doldurun: ${missingFields}`);
        return; // Devam etme
      }
      
      Modal.confirm({
        title: 'Referans eklemek istiyor musunuz?',
        content: 'Evet dediğinizde Referans bilgileri eklenecektir.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.addReferenceCode({
              code: values.code,
              name: values.name,
              height: values.height,
              width:values.width,
              subDepartmentId: "6575fe53f5358ec4a7a0d0b8",
              kod: values.kod,
              labelCategory: "BOS DUGME",
              labelType: "BOS DUGME",
              a: values.a,
              backgroundColor: values.backgroundColor,
              shape: '',
              shape2: '',
              line1:values.line1,
              line2:values.line2,
              line3:values.line3,
              line4:values.line4,
              upperline1:values.upperline1,
              upperline2:values.upperline2,
              upperline3:values.upperline3,
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })
              console.log("dataşöylegelid",response.data)
              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle
            }

          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
          console.log('Güncelleme iptal edildi.')
        }
      })
    }
    const handleReferanceSil = (id) => {
      Modal.confirm({
        title: 'Referansı silmek güncellemek istiyor musunuz?',
        content: 'Referans silindiğinde geri alınmayacaktır.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.deleteReferenceCode({
              id: id,
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })

              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle

            }
          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
          console.log('Güncelleme iptal edildi.')
        }
      })
    };
  
    const handleSearchmini = (value) => {
      console.log("valueeeee",value)
      setSearchText(value);
      const filtered = GrafDurum.filter((item) => {
        return (
          (item.code && item.code.includes(value)) || // code zaten string
          (item.height && String(item.height).includes(value)) || // height string'e dönüştürülüyor
          (item.width && String(item.width).includes(value)) || // width string'e dönüştürülüyor
          (item.name && item.name.includes(value)) // name zaten string
        );
      });
      setGrafDurum(value ? filtered : GrafDurumOld);
      
  
    };
    const minicolumnsgrafikdurum = [
      {
        title: 'Kod',
        dataIndex: 'code',
        key: 'code',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'İsim',
        dataIndex: 'name',
        key: 'name',
        render: (text) => (
          <Tooltip title={text}>
            <span style={{ fontSize: '12px' }}>
              {text.length > 20 ? `${text.substring(0, 20)}...` : text}
            </span>
          </Tooltip>
        ),

      },
      {
        title: 'Width',
        dataIndex: 'width',
        key: 'width',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Height',
        dataIndex: 'height',
        key: 'height',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Renk',
        dataIndex: 'backgroundColor',
        key: 'backgroundColor',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Açıklamakod',
        dataIndex: 'kod',
        key: 'kod',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      }, // Fazladan virgül bu satırdan kaldırıldı
      {
        title: 'İşlemler',
        key: 'actions',
        render: (text, reempty) => (
          <div
          onClick={(e) => {
        e.stopPropagation(); // Tıklama olayını üst katmanlara taşımayı engeller
        handleReferanceSil(reempty.id); // Silme işlemini tetikler
      }}
          style={{
            cursor: 'pointer', // Tıklanabilir hissiyatı verir
            padding: '5px 10px',
            backgroundColor: 'red',
            color: 'white',
            border: '1px solid red',
            borderRadius: '4px',
            display: 'inline-block',
            textAlign: 'center',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#cc0000'; // Hover rengi
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'red'; // Orijinal renk
          }}
        >
          Referans Sil
        </div>
        ),
      },
    ];
    const handleRowGrafDurumClick = (reempty) => {
      setSelectedRowData(reempty); // Satırdaki veriyi state'e aktar
      console.log("recoo",reempty);
      setIsRowModalVisible(true); // Modalı aç
    };

    const handleRowModalSave = () => {
      // Kaydetme işlemleri burada yapılır
      console.log("Kaydedilen Veri:", selectedRowData);
 
      const requiredFields = ['code', 'name', 'height','width', 'kod', 'a', 'backgroundColor'];
      const emptyFields = requiredFields.filter((field) => !selectedRowData[field]);

      // Eğer boş alan varsa hata döndür
      if (emptyFields.length > 0) {
        const fieldNames = {
          code: 'Kod',
          name: 'İsim',
          height: 'Yükseklik',
          width:'Genişlik',
          kod: 'Kod',
          a: 'A Değeri',
          backgroundColor: 'Arkaplan Rengi',
          line1:'Satır 1',
          line2:"Satır 2",
          line3:'Satır(ince) 1',
          line4:"Satır(ince) 2",
          upperline1:'Üst Satır 1',
          upperline2:'Üst Satır 2',
          upperline3:'Üst Satır 3',
        };
        const missingFields = emptyFields.map((field) => fieldNames[field]).join(', ');
        //message.error(`Lütfen şu alanları doldurun: ${missingFields}`);
        return; // Devam etme
      }
      Modal.confirm({
        title: 'Referans durumunu güncellemek istiyor musunuz?',
        content: 'Evet dediğinizde Referans bilgileri güncellenecektir.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.updateReferenceCode({
              id:selectedRowData.id,
              code: selectedRowData.code,
              name: selectedRowData.name,
              height: selectedRowData.height,
              width:selectedRowData.width,
              subDepartmentId: "6575fe53f5358ec4a7a0d0b8",
              kod: selectedRowData.kod,
              labelCategory: "MARKA KARTI",
              labelType: "MARKA KARTI",
              a: selectedRowData.a,
              backgroundColor: selectedRowData.backgroundColor,
              shape: '',
              shape2: '',
              line1:selectedRowData.line1,
              line2:selectedRowData.line2,
              line3:selectedRowData.line3,
              line4:selectedRowData.line4,
              upperline1:selectedRowData.upperline1,
              upperline2:selectedRowData.upperline2,
              upperline3:selectedRowData.upperline3,
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })
              console.log("responseee",response.data.data);
              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle

            }
          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
          console.log('Güncelleme iptal edildi.')
        }
      })
      // Örneğin, updateOrder fonksiyonuna gönderilebilir:

    
      setIsRowModalVisible(false); // Modalı kapat
    };
    
    const handleRowModalChange = (key, value) => {
      setSelectedRowData((prev) => ({ ...prev, [key]: value })); // Seçilen veriyi güncelle
    };
    return (
      <div>
        <Form
          form={form4}
          layout="horizontal"
          onFinish={onSipNoFinishGrafik}
          initialValues={{ radio: '1' }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            position: 'relative',
            flexShrink: 1,
            boxSizing: 'border-box',
            overflow: 'hidden',
            width: 700
          }}
          labelAlign="left"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: '16px',
              width: '100%'
            }}
          >
            <Form.Item label="Kod:" name="code" style={{ width:"100%",margin:0,padding:0 }}>
              <AntInput placeholder="Kod girin" />
            </Form.Item>
            <Form.Item label="İsim:" name="name" style={{ width:"100%",margin:0,padding:0  }}>
              <AntInput placeholder="İsim" />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", width: "100%" }}>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "50%",
      boxSizing: "border-box", // Eklenen box-sizing
      paddingTop:10,
    }}
  >
    <Form.Item label="Width:" name="width" style={{ width: "100%", margin: 0 }}>
      <AntInput placeholder="Width girin" />
    </Form.Item>
    <Form.Item label="Height:" name="height" style={{ width: "100%", marginTop: "10px",marginBottom:0}}>
      <AntInput placeholder="Height girin" />
    </Form.Item>
  




          <Form.Item label="Uzunkod:" name="kod" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="kod" />
    </Form.Item>
    <Form.Item label="Alt Satır1:" name="line1" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="line1" />
    </Form.Item>
    <Form.Item label="Alt Satır2:" name="line2" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="line2" />
    </Form.Item>
    <Form.Item label="Alt Satır(ince)1:" name="line3" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="line3" />
    </Form.Item>
    <Form.Item label="Alt Satır(ince)2:" name="line4" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="line4" />
    </Form.Item>
    </div>
    <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "50%",
      boxSizing: "border-box", // Eklenen box-sizing
      paddingTop:10,

      paddingLeft:10
    }}
  >
    
              <Form.Item label="Renk" name="backgroundColor" style={{margin:0,width:"100%"}}>
            <ClearableSelect
              value={form4.getFieldValue('backgroundColor') || ''}
              onChange={(value) => form4.setFieldsValue({ backgroundColor: value })}
              options={colordsx.map((ilk) => ({
                value: ilk.code,
                label: ilk.text,
              }))}
              placeholder="Renk Seçin"
              form={form4}
              name="backgroundColor"
            />
          </Form.Item>
    <Form.Item label="A:" name="a" style={{ width: "100%", marginTop: "10px",marginBottom:0 }}>
      <AntInput placeholder="A" />
    </Form.Item>
    <Form.Item label="Üst Satır1:" name="upperline1" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="upperline1" />
    </Form.Item>
    <Form.Item label="Üst Satır2:" name="upperline2" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="upperline2" />
    </Form.Item>
    <Form.Item label="Üst Satır3:" name="upperline3" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="upperline3" />
    </Form.Item>
    <Form.Item label="Üst Satır4:" name="upperline4" style={{ width: "100%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="upperline4" />
    </Form.Item>
  </div>
  </div>
    <Form.Item>
            <AntButton
              htmlType="submit"
              style={{
                width: '100%',
                marginTop: 10,
                backgroundColor: 'green',
                color: 'white',
                paddingTop: 15,
                paddingBottom: 15,
                fontSize: 15,
              }}
            >
              Kaydet
            </AntButton>
          </Form.Item>
  

          <div style={{ width: '100%' }}>
          <div style={{ width: '100%',display:"flex",flexDirection:"row",justifyContent:"flex-end" }}>
          <Form.Item>
          <AntInput
  placeholder="Ara"
  value={searchText}
  onChange={(e) => handleSearchmini(e.target.value)}
  onSearch={(value) => handleSearchmini(value)} // `onSearch` direkt `handleSearchmini` fonksiyonunu alabilir
  style={{ marginBottom: '0',width:"100%"}}
/>
</Form.Item>
</div>

            <Table
              columns={minicolumnsgrafikdurum}
              dataSource={GrafDurum} // Tablo verisi GrafDurum state'inden gelir
              rowKey="code"
              pagination={{ pageSize: 4 }}
              onRow={(reempty) => ({
                onClick: () => handleRowGrafDurumClick(reempty),

              })}
              components={{
    body: {
      row: (props) => (
        <tr {...props} style={{ height: '30px' }} /> // Satır yüksekliği burada ayarlanır
      ),
    },
  }}
            />
<Modal
  title="Referans Güncelle"
  visible={isRowModalVisible}
  onOk={handleRowModalSave}
  onCancel={() => setIsRowModalVisible(false)}
  okText="Güncelle" // "OK" yerine "Güncelle"
  cancelText="İptal" // "Cancel" yerine "İptal"
>
<Form 
  layout="inline" // Daha iyi düzen için "vertical"
  style={{ gap: '10px' }} // Form genel boşluk
>
  {/* Kod ve İsim Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Kod"
      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.code || ""}
        onChange={(e) => handleRowModalChange("code", e.target.value)}
      />
    </Form.Item>
    <Form.Item
      label="İsim"
      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.name || ""}
        onChange={(e) => handleRowModalChange("name", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Genişlik ve Yükseklik Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Genişlik"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.width || ""}
        onChange={(e) => handleRowModalChange("width", e.target.value)}
      />
    </Form.Item>
    <Form.Item
      label="Yükseklik"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.height || ""}
        onChange={(e) => handleRowModalChange("height", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Renk ve A Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Renk"

      style={{ width:"50%" }}
    >
      <ClearableSelect
        value={selectedRowData?.backgroundColor || ''}
        onChange={(value) => handleRowModalChange("backgroundColor", value)}
        options={colordsx.map((ilk) => ({
          value: ilk.code,
          label: ilk.text,
        }))}
        placeholder="Renk Seçin"
      />
    </Form.Item>
    <Form.Item
      label="A"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.a || ""}
        onChange={(e) => handleRowModalChange("a", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Uzunkod */}
  <Form.Item 
    label="Uzunkod" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.kod || ""}
      onChange={(e) => handleRowModalChange("kod", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Alt Satır1" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.line1 || ""}
      onChange={(e) => handleRowModalChange("line1", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Alt Satır2" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.line2 || ""}
      onChange={(e) => handleRowModalChange("line2", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Alt Satır(ince1)" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.line3 || ""}
      onChange={(e) => handleRowModalChange("line3", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Alt Satır(ince2)" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.line4 || ""}
      onChange={(e) => handleRowModalChange("line4", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Üst Satır1" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.upperline1 || ""}
      onChange={(e) => handleRowModalChange("upperline1", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Üst Satır2" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.upperline2 || ""}
      onChange={(e) => handleRowModalChange("upperline2", e.target.value)}
    />
  </Form.Item>
  <Form.Item 
    label="Üst Satır3" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.upperline3 || ""}
      onChange={(e) => handleRowModalChange("upperline3", e.target.value)}
    />
  </Form.Item>
</Form>

</Modal>

          </div>
       
        </Form>
      </div>
    )
  }
  const handleSaveOrder = () => {
    
    const errors = []
    const filteredValuesxx = values.emptyLabel.map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })
    const department = `${brand.split('_')[1]} / ${dept.split('_')[1]} / ${subDept}`;
    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });

    const path = `${brand}/${dept}/${subDept}`;

    if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    if(errors.length === 0)
    {
      saveOrder({ ...values, washingLabel: filteredValues, brand: brandId, department, path });
    }
  };
  const handleDisliModalClose = () => {
    setIsDisliModalVisible(false)
  }

  const handleDisliModalOpen = () => {
    setIsDisliModalVisible(true)
  }
  const handleUpdateOrder = () => {
    const errors = []
    const filteredValuesxx = values.emptyLabel.map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })
   if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }

    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });

    delete values.brandId;
    if(errors.length === 0)
    {
      updateOrder({ id: orderNo, body: { ...values, washingLabel: filteredValues, brand: brandId } });
    }
  };

  const ClearableSelect = ({ value, onChange, options, placeholder, form, name }) => {
    const handleClear = () => {
      form.setFieldsValue({ [name]: undefined });
      onChange(undefined);
    };

    return (
      <div style={{ position: "relative" }}>
        <Select
          showSearch
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: '100%' }}
          filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
          suffixIcon={<span style={{ display: 'none' }}></span>}
        >
          {options.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {value && (
          <RxCross1
            onClick={handleClear}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </div>
    );
  };

  return (
    <FieldArray name="emptyLabel">
      {({ push, remove }) => {
        fieldArrayPushRef.current = push; // Reference the `push` function
        console.log("alll valuess",values)
        return (
          <div>
            {values.emptyLabel.map((_, idx) => (
              <div className="grid grid-cols-2 gap-5 pb-5 relative" key={idx}>
                <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
                  <UIInput
                    label="Müşteri Sipariş No"
                    value={values.emptyLabel[idx]?.customerOrderNo}
                    onChange={(e) => {
                      setFieldValue(`emptyLabel[${idx}].customerOrderNo`, e.target.value);
                    }}
                  />
                  <FormikInput
                    label="Müşteri Sipariş Detayı"
                    name={`emptyLabel[${idx}].customerOrderDetail`}
                    autoComplete="off"
                  />
                  <FormikInput
                    label="Renk Kodu"
                    name={`emptyLabel[${idx}].colorCode`}
                    maxLength="3"
                    autoComplete="off"
                  />
          <DisliSayisiDetayModal
                  visible={isDisliModalVisible}
                  onCancel={handleDisliModalClose}
                  minWidth={'30%'} // modalType 4 ise minWidth 40%, aksi halde 30%
                  width={740}
                  title="Kemer Etiketi Referans Ekle"
                >
                  <DrawerContent4 />
                </DisliSayisiDetayModal>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                    <div style={{ width: '75%' }}>
                      <SelectReferanceCode8 name={`emptyLabel[${idx}].referanceCode`} />
                    </div>
                    <div style={{ width: '10%',display:"none" }}>
                    {user.companyName === "Şimşek Ege Etiket ve Matbaacılık\nLimited Şirketi" && 
                      user.tierType === "ADMIN" && (
  <div style={{ width: '20%', overflow:'hidden', marginRight:0}}>
    <UIButton
      type="button"
      variant="blue"
      onClick={handleDisliModalOpen}
      style={{width:'100%'}}
    >
      Referans Ekle
    </UIButton>
  </div>
)}
                    </div>

            
                  </div>
                  <FormikInput
                    type="number"
                    label="Adet"
                    name={`emptyLabel[${idx}].qauntity`}
                    autoComplete="off"
                  />
             
                </div>
                <div className="col-span-2 grid grid-cols-2 gap-x-5">
                  <div className="col-span-2">
                    {idx > 0 && (
                      <UIButton
                        variant="destructive"
                        onClick={() => remove(idx)}
                        className="absolute -right-40 top-0"
                      >
                        <X className="w-4 h-4 text-white" /> Renk Sil
                      </UIButton>
                    )}
                  </div>
                </div>
              </div>
            ))}

            <div className="flex items-center gap-x-5">
              {!orderNo && (
                <UIButton
                  type="submit"
                  variant="softgreen"
                  onClick={handleSaveOrder}
                  disabled={isPending}
                  className="w-full"
                >
                  {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Kaydet
                </UIButton>
              )}

              <UIButton
                type="button"
                onClick={orderNo ? handleUpdateOrder : handleSaveOrder}
                disabled={isPending || isPendingUpdate}
                className="w-full"
                variant={orderNo ? 'softgreen' : undefined}
              >
                {(isPending || isPendingUpdate) && <RotateCcw className="animate-spin mr-2" size={16} />} {orderNo ? 'Güncelle' : "Artwork'e Git"}
              </UIButton>

              {orderNo && (
                <Link
                  to={`/siparisler/artwork/${orderNo}?tab=${7}`}
                  target="_blank"
                  className="w-full"
                >
                  <UIButton type="button" disabled={isPending} className="w-full">
                    {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Artwork'e Git
                  </UIButton>
                </Link>
              )}

              <UIButton
                type="button"
                variant="blue"
                onClick={() => {
                  push({
                    ...values.emptyLabel[0],
                    colorCode: '',
                    sizeDefectivePercent: '',
 
                  });
                }}
                className="w-full"
              >
                Renk Ekle
              </UIButton>
            </div>
          </div>
        );
      }}
    </FieldArray>
  );
}
